import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobInfo: null,
  moduleCategory: null,
  fetchedResponse: null,
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setEvInvoiceReportData(state, action) {
      return {
        jobInfo: action.payload.jobInfo,
        moduleCategory: action.payload.moduleCategory,
        fetchedResponse: action.payload.fetchedResponse,
      };
    },
    setReleaseNoteData(state, action) {
      return {
        jobInfo: action.payload.jobInfo,
        moduleCategory: 1,
        fetchedResponse: null,
      };
    },
    resetState() {
      return initialState;
    },
    setMultipleEvInvoiceReportData(state, action) {
      return {
        evInvData: action.payload.evInvData,
        moduleCategory: action.payload.moduleCategory,
        IsDifferentTypeSelect: action.payload.IsDifferentTypeSelect,
      };
    },
  },
});

export const reportActions = reportSlice.actions;
export default reportSlice;
